import _ from 'lodash';

import React from "react";
import update from 'immutability-helper';

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

// core components
import { SchemaForm, utils } from "components/material-ui-schema-form/index";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import withStyles from "material-ui/styles/withStyles";
import Select from "material-ui/Select";
import MenuItem from "material-ui/Menu/MenuItem";
import InputLabel from "material-ui/Input/InputLabel";
import FormControl from "material-ui/Form/FormControl"
import InputAdornment from "material-ui/Input/InputAdornment";
import Button from "components/CustomButtons/Button.jsx";

import {createSpeaker} from "../../graph";

import Loading from "../../../etc/Loading";
import { createDemogKey, hasOnlyDigits } from "../../utils";
import Snackbar from "../CustomErrorSnackBar";
import {client} from "client";
import {emergencyNumbers} from "constants/EmergencyNumbers";


class Step2 extends React.Component {
  constructor(props) {
    super(props);

    this.conf = null;
    this.modelTemp = {};

    this.state = {
      schema: null,
      form: null,
      model: null,
      formState: "",
      keyState: 0, 
      errorSnackbarOpen: false, 
      formErrorMessage: ""
    };
  }

  componentDidMount() {
    this.conf = this.props.props.data.conf;
  }

  // createSpeaker(pid, phonenumber, countryCode) {
  //   client.mutate({
  //     mutation: createSpeaker,
  //     variables: {
  //       pid: pid,
  //       phonenumber: phonenumber,
  //       countryCode: countryCode,
  //     }
  //   }).then((data) => {
  //     const resp = JSON.parse(data.data.createSpeaker.jsonObject);
  //     this.props.props.collectDataCallback('caller_speakerid', resp.speakerId);
  //     this.props.props.collectDataCallback('caller_speakerpk', resp.speakerPk);
  //   }).catch((data) => {
  //     this.props.props.collectDataCallback('caller_speakerid', "");
  //   });
  // }

  onModelChange(key, val) {
    let newModel = this.state.model;
    utils.selectOrSet(key, newModel, val);
    this.setState({ model: newModel });
    
    let result = utils.validateBySchema(this.state.schema, this.state.model);
    if (result.valid){
      this.setState({formState: "success"});
      this.closeErrorSnackbar();
    }
    else
      this.setState({formState: null});
  }

  isValidated() {
    let region = 0;

    if (this.state.model.caller_region)
      region = this.state.model.caller_region;

    // this.createSpeaker(
    //   this.props.props.data.pid,
    //   parseInt(this.state.model.caller_number),
    //   parseInt(this.state.model.caller_countrycode)
    // )

    let age = parseInt(this.state.model.caller_age);
    let cc = parseInt(this.state.model.caller_countrycode);

    if (!hasOnlyDigits(this.state.model.caller_number)) {
      this.openSnackBar("Phone number should be a number", 1);
      return false;
    }

    if (cc) {
      let en = _.find(emergencyNumbers, {callingCode: parseInt(cc)});

      let num = this.state.model.caller_number;
      let enFound = false;
      let enFNumber = "";

      for (const i in en.emergencyNumbers) {
        const l = en.emergencyNumbers[i].length;
        const valSplice = num.toString().slice(0, l);

        if (parseInt(en.emergencyNumbers[i]) === parseInt(valSplice)) {
          enFNumber = en.emergencyNumbers[i];
          enFound = true;
          break;
        }
      }

      if (enFound) {
        this.openSnackBar(`Emergency number found (${enFNumber})`, 1);
        return false;
      }
    }
    
    if (!age || !hasOnlyDigits(this.state.model.caller_age)) {
      this.openSnackBar("Age should be a number", 1);
      return false;
    }
    else {
      const max = this.state.schema.properties.caller_age.max;
      const min = this.state.schema.properties.caller_age.min;

      if (age < min || age > max) {
        this.openSnackBar(`Age should be ${min}-${max}.`, 1);
        return false;
      }
    }

    if (this.state.formState === "success") {
      this.props.props.collectDataCallback('caller', this.state.model);

      return true;
    } else {
      let result = utils.validateBySchema(this.state.schema, this.state.model);
      if (result.valid) {
        this.closeErrorSnackbar();
        this.props.props.collectDataCallback('caller', this.state.model);
        return true;
      }
      else {
        this.openSnackBar(result, 0)
      }
    }

    return false;
  }

  autoFillDemogFormData(propType, props, demogData) {
    const propsTitleToSkip = ["Carrier", "Country Code", "Number", "Speaker ID"];
    let i = 0;

    if (!demogData){
      return;
    }
    else if (demogData.length != (props.length-3)){
      i = this.state.keyState;
      this.setState({
        schema: this.conf["properties"]["caller_props"],
        form: this.conf["properties"]["caller_props"]["ui:order"],
        model: this.conf["form_data"]["caller_props"],
        keyState: i + 1
      });
      return;
    }

    const l = props.length;

    for (const prop in props) {
        let value = "";

        if (propsTitleToSkip.includes(props[prop]["title"])) {
            i++;
            continue;
        }

        if (props[prop]["title"] === "Age") {
            value += demogData.shift();
            value += demogData.shift();
        }
        else {
            if (props[prop]["enum"]) {
                const cpLength = props[prop]["enum"][0].toString().length;

                for (let x=0; x < cpLength; x++) {
                    value += demogData.shift();
                }
            }
            else {
                value += demogData.shift();
            }
        }

        if (props[prop]["type"] === "number")
            value = parseInt(value);

        const demogkey = createDemogKey(props[prop]);

        this.modelTemp[demogkey] = value;
        i++;
    }

    i = this.state.keyState;
    this.setState({
      schema: this.conf["properties"]["caller_props"],
      form: this.conf["properties"]["caller_props"]["ui:order"],
      model: this.modelTemp,
      keyState: i + 1
    });
  }

  clearAutoFillDemogs(schema) {
    const schemaOrder = schema["ui:order"];
    const schemaProperties = schema["properties"];

    for (let i in schemaOrder) {
      if (typeof schemaOrder[i] === "object") {
        this.conf["form_data"]["caller_props"][schemaOrder[i]["key"]] = schemaProperties[schemaOrder[i]["key"]]["default"];
      }
      else {
        if (schemaProperties[schemaOrder[i]]["type"] === "string")
          this.conf["form_data"]["caller_props"][schemaOrder[i]] = "";
        else
          this.conf["form_data"]["caller_props"][schemaOrder[i]] = 0;
      }
    }
  }

  autoFillDemogs() {
    const data = this.props.props.getDataCallback("autoFill");
    const demogs = data["checkPin"]["pinlog"];
    const speakerInline = data["checkPin"]["speakerInline"];

    if (!demogs && !speakerInline) {
      this.clearAutoFillDemogs(this.conf["properties"]["caller_props"]);

      let i = this.state.keyState;

      this.setState({
        keyState: i + 1,
        schema: this.conf["properties"]["caller_props"],
        form: this.conf["properties"]["caller_props"]["ui:order"],
        model: this.conf["form_data"]["caller_props"]
      });
      return;
    }

    const callerProps = _.sortBy(this.conf["properties"]["caller_props"]["properties"], function(o) { return o.order });

    const callerDemographic = demogs["demographicInline"].toString().split("");

    if (speakerInline) {
        // this.callerNumberValue = speakerInline.phonenumber;
        this.modelTemp["caller_number"] = speakerInline.phonenumber.toString();
        this.modelTemp["caller_speakerid"] = speakerInline.speakerId;
    }

    this.modelTemp["caller_carrier"] = '';
    this.modelTemp["caller_countrycode"] = '';

    this.autoFillDemogFormData("caller_props", callerProps, callerDemographic);
  }

  openSnackBar(message, type){
    if (type == 1) {
      this.setState({
        errorSnackbarOpen: true,
        formErrorMessage: `ERROR! -- ${message}`
      }); 
    }
    else {
      let dataPath = message.error.dataPath.replace('\/', '').replace('caller_','');
      this.setState({
        errorSnackbarOpen: true, 
        formErrorMessage: `ERROR! -- ${dataPath}: ${message.error.message}`
      });
    }
  }

  closeErrorSnackbar(){
    this.setState({
      errorSnackbarOpen: false, 
    })
  }

  render() {
    //need to change; ugly solution to know if next was clicked on wizard and step 2 is current page
    //this will handle the auto fill with the data coming from step 1 -ray
    if (this.props.props.getDataCallback("step2Next") === 1 ) {
      setTimeout(() => {
        if (!this.props.props.getDataCallback("step2FirstRender")) {
          this.autoFillDemogs();
          this.props.props.collectDataCallback("step2FirstRender", 2);
        }
      }, 0);
    }

    const { schema, form, model, keyState } = this.state;

    if (!schema && !form && !model)
      return (<Loading />);
    return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12}>
          <h4 style={{textAlign: "center"}}>
            Caller Form
          </h4>
          
          <SchemaForm key={`callerform-${keyState}`} schema={schema} form={form} model={model} onModelChange={this.onModelChange.bind(this)}/>

          <Snackbar 
            formErrorMessage={this.state.formErrorMessage}
            errorSnackbarOpen={this.state.errorSnackbarOpen}
            closeErrorSnackbar={this.closeErrorSnackbar.bind(this)}
          />
        </ItemGrid>
      </GridContainer>
    );
  }
}

export default withStyles(sweetAlertStyle)(Step2);



// WEBPACK FOOTER //
// ./src/views/callform/components/WizardSteps/Step2.jsx